module.exports = __webpack_public_path__ + "img/pantalla-10-1.94a57825.png";